import {
  BadgeCheck,
  KeyRound,
  LayoutGrid,
  Network,
  ScrollText,
  ShieldAlert,
  ShieldCheck,
  UserPlus,
  Users
} from 'lucide-react'
import type { ReactNode } from 'react'

import { OrganizationRole } from 'src/api/main'
import { normalizeWorkspaceAccessRole } from 'src/utils/workspaceAuthorization'

export const SUGGESTION_ICON_SIZE = 16
export const SUGGESTION_ICON_BOX = 28

export type ChatSuggestion = {
  key: string
  localeKey: string
  icon: ReactNode
}

type SuggestionGroup = { key: string; icon: ReactNode }

const SUGGESTIONS: Record<OrganizationRole, SuggestionGroup[]> = {
  [OrganizationRole.OWNER]: [
    { key: 'admins', icon: <ShieldCheck size={SUGGESTION_ICON_SIZE} /> },
    {
      key: 'securityReview',
      icon: <ShieldAlert size={SUGGESTION_ICON_SIZE} />
    },
    { key: 'accessChanges', icon: <ScrollText size={SUGGESTION_ICON_SIZE} /> },
    { key: 'orgChart', icon: <Network size={SUGGESTION_ICON_SIZE} /> }
  ],
  [OrganizationRole.ADMIN]: [
    { key: 'members', icon: <Users size={SUGGESTION_ICON_SIZE} /> },
    { key: 'inviteMember', icon: <UserPlus size={SUGGESTION_ICON_SIZE} /> },
    { key: 'signInMethods', icon: <KeyRound size={SUGGESTION_ICON_SIZE} /> },
    { key: 'accessChanges', icon: <ScrollText size={SUGGESTION_ICON_SIZE} /> }
  ],
  [OrganizationRole.EMPLOYEE]: [
    { key: 'myTeam', icon: <Users size={SUGGESTION_ICON_SIZE} /> },
    { key: 'orgChart', icon: <Network size={SUGGESTION_ICON_SIZE} /> },
    { key: 'myApps', icon: <LayoutGrid size={SUGGESTION_ICON_SIZE} /> },
    { key: 'myAccess', icon: <BadgeCheck size={SUGGESTION_ICON_SIZE} /> }
  ]
}

export const resolveSuggestionRole = (
  accessRole: string | undefined
): OrganizationRole => {
  const normalized = normalizeWorkspaceAccessRole(accessRole)

  return normalized === OrganizationRole.OWNER ||
    normalized === OrganizationRole.ADMIN
    ? normalized
    : OrganizationRole.EMPLOYEE
}

export const getChatSuggestions = (role: OrganizationRole): ChatSuggestion[] =>
  SUGGESTIONS[role].map(({ key, icon }) => ({
    key,
    localeKey: `${role}.${key}`,
    icon
  }))
